export default "__VITE_ASSET__DpYYVneA__"